import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamWorkOrderPermissionSet {
  View = 'eam_work_order_view',
  Write = 'eam_work_order_write',
}

export const EamWorkOrderPermissions = {
  [EamWorkOrderPermissionSet.View]: [
    PermissionType.GET_ANY_EAM_WORK_ORDER,
    PermissionType.GET_ANY_EAM_VMRS_COMPONENTS,
    PermissionType.RECEIVE_EAM_WORK_ORDER_COMPLETED_ALERT,
  ],
  [EamWorkOrderPermissionSet.Write]: [
    PermissionType.WRITE_ANY_EAM_WORK_ORDER,
    PermissionType.GET_ANY_EAM_VMRS_COMPONENTS,
    PermissionType.WRITE_ANY_EAM_PHOTO,
  ],
}

export const eamWorkOrderPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EamWorkOrder,
  active: EamWorkOrderPermissions,
  unAssignablePermissionSets: [],
}
